// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"fc09ac8e","629":"25fe8934"}[chunkId] + ".chunk.js";
};